module.exports = __webpack_public_path__ + "img/img-c8e568.png";